import { Box, Dialog, useTheme } from "@mui/material"

import { FeatureDetail } from "components/domains/features"
import { FeatureListDetail } from "./FeatureListDetail"
import { FeatureSummary } from "./domains/features/FeatureSummary"

export const DesktopFeatureDialog = ({
  open,
  onClose,
  directionButtonProps = {},
  loading = true,
  data,
  onNavigate,
  isMultiOrdinalVenue,
  ...props
}) => {
  const theme = useTheme()
  const { dialog, contentContainer, featureListRoot } =
    theme.components[`AppDesktopFeatureDialog`]?.styleOverrides || {}

  const {
    feature,
    zone,
    logo,
    category,
    level,
    name,
    hours,
    id,
    website,
    gallery,
    promotions,
    privileges,
    description,
    relatedOccupants,
    venueLogo,
  } = data || {}

  const isSection = feature?.feature_type === "section"

  return (
    <Dialog
      open={open}
      onClose={onClose}
      hideBackdrop
      disableEnforceFocus
      sx={dialog}
      {...props}
    >
      <Box sx={contentContainer}>
        <FeatureSummary
          id={id}
          name={name}
          hours={hours}
          level={isMultiOrdinalVenue && level}
          category={category}
          logo={logo}
          zone={zone}
          loading={loading}
          venueLogo={venueLogo}
          onNavigate={onNavigate}
          DirectionButtonProps={directionButtonProps}
        />
        {isSection ? (
          <FeatureListDetail
            sx={featureListRoot}
            list={relatedOccupants}
            loading={loading}
          />
        ) : (
          <FeatureDetail
            feature={feature}
            onClose={onClose}
            website={website}
            gallery={gallery}
            promotions={promotions}
            privileges={privileges}
            description={description}
            loading={loading}
          />
        )}
      </Box>
    </Dialog>
  )
}
